/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import QboSyncStatusPanel from './QboSyncStatusPanel';
const mockQueryClient = new QueryClient({
    defaultOptions: { queries: { retry: false } }
});
const meta = {
    title: 'Features/Settings/Integrations/QboSyncStatusPanel',
    component: QboSyncStatusPanel,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement(QueryClientProvider, { client: mockQueryClient },
            React.createElement("div", { style: { maxWidth: '640px', margin: '40px auto' } },
                React.createElement(Story, null))))
    ]
};
export default meta;
export const Default = {};
